"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompetencyRoleCompetencyAssignmentSchema () {
        return CompetencyRoleCompetencyAssignmentSchema;
    },
    get CompetencyRoleSchema () {
        return CompetencyRoleSchema;
    },
    get CompetencyRoleStatusSchema () {
        return CompetencyRoleStatusSchema;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _base = require("../base");
const _useractionrecord = require("../shared/user-action-record");
const _constants = require("./constants");
const CompetencyRoleStatusSchema = _zod.z.enum([
    "active",
    "archived"
]).default("active");
const CompetencyRoleCompetencyAssignmentSchema = _zod.z.object({
    competency_id: _zod.z.instanceof(_bson.ObjectId),
    expected_level: _zod.z.number().int().min(1).max(_constants.MAX_COMPETENCY_LEVELS).nullable().default(null)
});
const CompetencyRoleSchema = _base.BaseDocument.extend({
    name: _zod.z.string(),
    description: _zod.z.string().default(""),
    external_id: _zod.z.string().nullable().default(null),
    status: CompetencyRoleStatusSchema,
    competencies: _zod.z.array(CompetencyRoleCompetencyAssignmentSchema).default([]),
    created: _useractionrecord.UserActionRecord,
    updated: _useractionrecord.UserActionRecord
});
